// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}


/* Style for the phone input container */
.react-tel-input .form-control {
  width: 100%;
  height: 40px;
  font-size: 1rem;
  border-radius: 4px 4px 0 0;
  border-color: rgba(0, 0, 0, 0.23);
  border-width: 0 0 1px 0;
  background-color: transparent;
  transition: all 0.3s;
}

/* Style for the phone input when focused */
.react-tel-input .form-control:focus {
  border-width: 0 0 2px 0 !important;
  border-color: #E56417 !important; /* Orange color */
  box-shadow: none !important;
  outline: none;
}

/* Style for the country select button */
.react-tel-input .flag-dropdown {
  background-color: transparent;
  border: none;
}

/* Style for the country select button when the input is focused */
.react-tel-input .form-control:focus ~ .flag-dropdown {
  border: none;
}

/* Remove focus styles from the country select button */
.react-tel-input .selected-flag:focus {
  background-color: transparent;
}

/* Adjust placeholder color */
.react-tel-input .form-control::placeholder {
  color: rgba(0, 0, 0, 0.54);
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;;AAGA,wCAAwC;AACxC;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,0BAA0B;EAC1B,iCAAiC;EACjC,uBAAuB;EACvB,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA,2CAA2C;AAC3C;EACE,kCAAkC;EAClC,gCAAgC,EAAE,iBAAiB;EACnD,2BAA2B;EAC3B,aAAa;AACf;;AAEA,wCAAwC;AACxC;EACE,6BAA6B;EAC7B,YAAY;AACd;;AAEA,kEAAkE;AAClE;EACE,YAAY;AACd;;AAEA,uDAAuD;AACvD;EACE,6BAA6B;AAC/B;;AAEA,6BAA6B;AAC7B;EACE,0BAA0B;AAC5B","sourcesContent":["body {\r\n  margin: 0;\r\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\r\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\r\n    sans-serif;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n}\r\n\r\ncode {\r\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\r\n    monospace;\r\n}\r\n\r\n\r\n/* Style for the phone input container */\r\n.react-tel-input .form-control {\r\n  width: 100%;\r\n  height: 40px;\r\n  font-size: 1rem;\r\n  border-radius: 4px 4px 0 0;\r\n  border-color: rgba(0, 0, 0, 0.23);\r\n  border-width: 0 0 1px 0;\r\n  background-color: transparent;\r\n  transition: all 0.3s;\r\n}\r\n\r\n/* Style for the phone input when focused */\r\n.react-tel-input .form-control:focus {\r\n  border-width: 0 0 2px 0 !important;\r\n  border-color: #E56417 !important; /* Orange color */\r\n  box-shadow: none !important;\r\n  outline: none;\r\n}\r\n\r\n/* Style for the country select button */\r\n.react-tel-input .flag-dropdown {\r\n  background-color: transparent;\r\n  border: none;\r\n}\r\n\r\n/* Style for the country select button when the input is focused */\r\n.react-tel-input .form-control:focus ~ .flag-dropdown {\r\n  border: none;\r\n}\r\n\r\n/* Remove focus styles from the country select button */\r\n.react-tel-input .selected-flag:focus {\r\n  background-color: transparent;\r\n}\r\n\r\n/* Adjust placeholder color */\r\n.react-tel-input .form-control::placeholder {\r\n  color: rgba(0, 0, 0, 0.54);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
